module.exports = __webpack_public_path__ + "static/media/poop-bag.9476abee.png";